const s = {
  name: "Earpods",
  dimensions: { width: 28, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 28 40" style="enable-background:new 0 0 28 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M6,16v-4c3.3,0,6-2.7,6-6S9.3,0,6,0C2.7,0,0,2.7,0,6v10h2v24h2V16H6z M2,6c0-2.2,1.8-4,4-4s4,1.8,4,4
			s-1.8,4-4,4S2,8.2,2,6z M4,11.7V14H2v-3.5C2.6,11,3.3,11.4,4,11.7z"/>
		<path class="st0" d="M22,12c3.3,0,6-2.7,6-6s-2.7-6-6-6s-6,2.7-6,6v10h2v24h2V16h2V12z M18,6c0-2.2,1.8-4,4-4c2.2,0,4,1.8,4,4
			s-1.8,4-4,4C19.8,10,18,8.2,18,6z M18,10.5c0.6,0.5,1.3,0.9,2,1.2V14h-2V10.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Earpods
};
